import { useState } from 'react';

function ControlSection({ label, defaultExpanded = true, children, ui }) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className="mb-1">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center justify-between w-full py-2"
        style={{ color: ui.text }}
      >
        <span className="text-xs font-medium" style={{ color: ui.textSecondary }}>
          {label}
        </span>
        <span className="text-[10px]" style={{ color: ui.textSecondary }}>
          {expanded ? '\u25BE' : '\u25B8'}
        </span>
      </button>
      {expanded && (
        <div className="pb-3">{children}</div>
      )}
      <div className="border-b" style={{ borderBottomColor: ui.borderSecondary }} />
    </div>
  );
}

export default ControlSection;
